import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TariffPlanList } from "../components/TariffPlanList/TariffPlanList";
import { ChecksTopUpSection } from "../components/ChecksTopUpSection/ChecksTopUpSection";
import "./Tariffs.scss";

export const Tariffs = () => {
  const navigate = useNavigate();

  return (
    <div className="tariffs-page">
      <div className="tariffs-container">
        <div className="tariffs-top-bar">
          <button type="button" className="tariffs-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
            <span>Назад</span>
          </button>
        </div>
        <h1 className="tariffs-title">Тарифы</h1>
        <p className="tariffs-subtitle">
          Выберите тарифный план или докупите проверки к активному периоду.
        </p>
        <TariffPlanList />
        <ChecksTopUpSection />
      </div>
    </div>
  );
};
